export const useLoginUserMutation = () => {
  const mockUser = {
    id: 1,
    name: 'Demo',
    family: 'User',
    mobile_number: '00123456789',
    email: 'demo@example.com',
    address: 'England',
    register_date: '2025-01-01',
  };

  const trigger = async (payload) => {
    const response = {
      data: {
        message: 'Login successful (static mode)',
        user: mockUser,
      },
    };
    return response;
  };

  return [trigger, { data: null, error: null, isError: false, isSuccess: false, isLoading: false }];
};
